import { gql } from '@apollo/client';
const SPECIFICATION_HEADER = gql `
  fragment SpecificationHeaderFragment on ModelSpecificationNode {
    id
    modifiedDate
    createdDate
    archivedAt
    itemCode
    state
    fancyName
    category {
      id
      name
      image
    }
    folder {
      id
      name
      modelSpecificationsCount
    }
    season {
      name
    }
    status {
      id
      namePL
      nameEN
      color
    }
    image
    componentsCount
    components {
      edges {
        node {
          id
          name
          photo
          productCategory {
            id
            type
            typeLabelPL
            typeLabelEN
            typeIcon
          }
        }
      }
    }
    brand {
      name
    }
    assignedOrderId
  }
`;
export default SPECIFICATION_HEADER;
